import {ACTION_CODE} from './_actionCode';
import {NotificationService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'GET_COUNT_NOTIFICATION';

export async function getCount(userData: Record<string, string>) {
    try {
        LoggerService.logInfo('Action - getCount - Start');

        const getCountResult = await NotificationService.getCount(userData);

        LoggerService.logInfo('Action - getCount - Success');

        return ResultModel.newSuccessResult(getCountResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - getCount - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération du nombre de notifications',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
